import { action, computed, makeObservable, observable } from 'mobx';

import { ILocalStore } from '@/stores/interfaces/ILocalStore';

import {
  getInitialMetaState,
  getLoadedErrorMeta,
  getLoadedSuccessMeta,
  getLoadingStartMeta,
  isInitialMetaState,
  Meta,
} from './types';

/**
 * Mobx класс для флажков isLoading и isError, Возможно потом будет расширяться
 * */
export class MetaStore implements ILocalStore {
  data: Meta;

  constructor(meta?: Meta) {
    this.data = meta || getInitialMetaState();

    makeObservable<MetaStore>(this, {
      data: observable.ref,
      isLoading: computed,
      isError: computed,
      isLoaded: computed,
      isInitialMetaState: computed,
      setLoadedStartMeta: action.bound,
      setLoadedSuccessMeta: action.bound,
      setLoadedErrorMeta: action.bound,
      isStaleLoaded: computed,
      reset: action.bound,
    });
  }

  get isLoading(): boolean {
    return this.data.isLoading;
  }

  get isError(): boolean {
    return this.data.isError;
  }

  get isInitialMetaState(): boolean {
    return isInitialMetaState(this.data);
  }

  get isStaleLoaded(): boolean {
    return this.data.isLoaded || this.data.isError;
  }

  get isLoaded(): boolean {
    return this.data.isLoaded;
  }

  reset(): void {
    this.data = getInitialMetaState();
  }

  setLoadedStartMeta(): void {
    this.data = getLoadingStartMeta();
  }

  setLoadedSuccessMeta(): void {
    this.data = getLoadedSuccessMeta();
  }

  setLoadedErrorMeta(): void {
    this.data = getLoadedErrorMeta();
  }

  static merge = (...items: MetaStore[]): MetaStore => {
    if (items.some((item) => item.isError)) {
      return new MetaStore(getLoadedErrorMeta());
    }

    if (items.some((item) => item.isLoading)) {
      return new MetaStore(getLoadingStartMeta());
    }

    /**
     * Считаем общую мету успешной, если успешные все стартовавшие запросы
     */
    if (items.every((item) => item.isLoaded || isInitialMetaState(item))) {
      return new MetaStore(getLoadedSuccessMeta());
    }

    return new MetaStore();
  };

  destroy() {}
}
